<template>
  <div>
    <header>
      <HeaderTalkshows />
      <BreadcrumbList />
    </header>
    <div id="main">

      <section class="talkshow">

        <div class="talkshowTitle">
          <div class="inner4">
            <h1>トークショーレポート</h1><p class="titleSub">Talk Show Reports</p>
          </div><!-- /inner4-->
        </div><!-- /talkshowTitle-->

        <div class="talkshowAbout">
          <div class="inner4">
            <p  style="text-align: center">
              トークショーのレポートページです。文字と大きなサイズの画像でトークショーをまとめています。
            </p>
          </div><!-- /inner-->
        </div><!-- /talkshowAbout-->

        <div class="scheduleMenu">
          <div class="scheduleList">
            <div class="inner4">
              <h3  style="text-align: center">
                現在、レポートページが作成されているトークショーはありません。
              </h3>
            </div>
          </div>
        </div>

      </section>
    </div>
    <Footer />
  </div>
</template>
<script>
import HeaderTalkshows from '@/components/modules/HeaderTalkshows.vue'
import BreadcrumbList from '@/components/modules/BreadcrumbList.vue'
import Footer from '@/components/modules/Footer.vue'

export default {
  components: {
    HeaderTalkshows,
    BreadcrumbList,
    Footer
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    setTitleAndDescription (to) {
      document.title = (to.meta.title ? to.meta.title : '')
      document.querySelector("meta[name='description']").setAttribute('content', (to.meta.desc ? to.meta.desc : ''))
    }
  },
  computed: {
  },
  mounted () {
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  watch: {
    $route: function (to, from) {
      this.setTitleAndDescription(to)
    }
  }
}
</script>

<style scoped>
.withRightLine {
  border-right: 1px solid #000;
}
.withLeftLine {
  border-left: 1px solid #000;
}

</style>
